import { render } from "./Layout.vue?vue&type=template&id=2c183d2e"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=2c183d2e&lang=css"
script.render = render

export default script